import { render, staticRenderFns } from "./UserReviewRecords.vue?vue&type=template&id=760efc18&"
import script from "./UserReviewRecords.vue?vue&type=script&lang=js&"
export * from "./UserReviewRecords.vue?vue&type=script&lang=js&"
import style0 from "./UserReviewRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports